module.exports = __webpack_public_path__ + "static/media/star_badge_green.630eb486.svg";